import { Box, CTALink, Heading, Stack } from '@99designs/emu';
import { DesignInspiration } from '@99designs/feature-design-inspiration';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { Desktop, Mobile } from '@99designs/spa-common';
import { industries } from '../../utils/industries';
import type { Design } from '@99designs/feature-design-inspiration';

type Props = {
    categoryKeys: string[];
    designs: Design[];
    industry?: string;
};

export function Inspiration({ categoryKeys, designs, industry }: Props) {
    const categoryKeysParams = categoryKeys.join(',');
    const industryLabel = industry && industries().find((i) => i.value === industry)?.label;

    return (
        <Stack space={['0.5bu', '0.5bu', '1bu', '1bu']}>
            <Box display="flex" justifyContent="center">
                <Box
                    width="100%"
                    maxWidth="1300px"
                    display="flex"
                    justifyContent="space-between"
                    flexWrap="wrap"
                    paddingX="2bu"
                >
                    <Box paddingRight="1bu" paddingBottom={['none', 'none', '0.5bu', '0.5bu']}>
                        <Heading appearanceLevel={3} accessibilityLevel={2}>
                            {industryLabel
                                ? formatMessage(
                                      __('{industryLabel} designs created on 99designs'),
                                      {
                                          industryLabel,
                                      }
                                  )
                                : __('Branding designs created on 99designs')}
                        </Heading>
                    </Box>
                    <Desktop>
                        <CTALink href={`/discover?category=${categoryKeysParams}`}>
                            {__('See more inspiration')}
                        </CTALink>
                    </Desktop>
                </Box>
            </Box>
            <DesignInspiration designs={designs} />
            <Box display="flex" justifyContent="center">
                <Box width="100%" maxWidth="1300px" paddingX="2bu">
                    <Mobile>
                        <CTALink href={`/discover?category=${categoryKeysParams}`}>
                            {__('See more inspiration')}
                        </CTALink>
                    </Mobile>
                </Box>
            </Box>
        </Stack>
    );
}
